<template>
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 453.2 453.2"
        style="enable-background: new 0 0 453.2 453.2"
        xml:space="preserve"
        :id="id"
    >
        <svg:style type="text/css">
            #{{ id }} > .b5-st0 {
                fill: {{ color }};
            }
        </svg:style>
        <path
            class="b5-st0"
            d="M286.1,181.5c-11.7,0.2-21,9.9-20.8,21.5c0.2,11.7,9.9,21,21.5,20.8c11.5-0.2,20.8-9.6,20.8-21.2
	C307.5,190.9,297.9,181.4,286.1,181.5z"
        />
        <ellipse class="b5-st0" cx="155.4" cy="202.7" rx="21.5" ry="21.1" />
        <ellipse class="b5-st0" cx="220.1" cy="202.7" rx="21.5" ry="21.1" />
        <path
            class="b5-st0"
            d="M226.6,0C101.5,0,0,101.4,0,226.6s101.5,226.6,226.6,226.6s226.6-101.5,226.6-226.6S351.8,0,226.6,0z
	 M266.5,332.7c-11.2,10.6-22.5,23.8-30.5,39.2c-0.5,1.4-1.2,2.7-1.9,3.9c-13.2,21.7-23.4,0-23.4,0c-7-14.6-17.4-30.8-32.1-44.5
	c-53.2-18.7-91.3-68.9-91.3-127.9c0-75,61.5-135.7,137.3-135.7s137.3,60.8,137.3,135.7C361.8,263.9,321.8,315.1,266.5,332.7
	L266.5,332.7z"
        />
    </svg>
</template>

<script>
export default {
    name: "Bubble5",
    data() {
        return {
            id: "b5" + Math.ceil(Math.random() * 1000),
        };
    },
    props: {
        color: {
            type: String,
            default: "#2b2b2b",
        },
    },
};
</script>
